._1dw8t850 {
  color: var(--_1qu8za24);
}
._1dw8t851 {
  max-width: 405px;
}
._1dw8t852 {
  margin-bottom: 10px;
  text-align: center;
}
._1dw8t853 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  text-align: center;
}
._1dw8t854 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  margin-top: 28px;
}